export enum RaceDetailsComponentType {
  EDIT,
  ADD,
  EVENT_COPY,
  RACE_COPY,
}

